
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"255","height":"255","viewBox":"0 0 67.469 67.469","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.768 13.054a26.38 26.38 0 0112.347 22.338h0a26.38 26.38 0 01-26.38 26.38 26.38 26.38 0 01-26.381-26.38A26.38 26.38 0 0120.56 12.536","fill":"none","stroke":"#f5f5f5","stroke-width":"10.583"}}),_c('path',{attrs:{"d":"M27.555 28.166l-8.674-13.88L10.207.403l10.584 3.038 10.583 3.037-1.91 10.844z","fill":"#f5f5f5"}})])
          )
        }
      }
    